const defaultProps = Object.freeze({
    addressForm: {
        address: null,
        linkedid: 0,
        linkedtype: '',
        apiEndpoint: '',
        isAccountAddress: false,
        callback: () => {},
    },
    automationWizardPanel: {
        template: null,
        automation: null,
        isEditMode: false,
        readOnly: false,
    },
    assignedStaffLabelsModal: {
        assignedStaffLabels: [],
        callback: null,
    },
});
const store = {
    namespaced: true,
    state: {
        opportunityForm: {
            display: false,
            props: {
                oppId: null,
                mode: 'edit',
                linkedid: 0,
                linkedtype: null,
                emitEditSuccess: '',
                context: '',
            },
        },
        addressForm: {
            display: false,
            props: defaultProps.addressForm,
        },
        customfieldForm: {
            display: false,
            props: {
                linkedid: 0,
                linkedtype: '',
                emitEditSuccess: '',
                route: '',
            },
        },
        documentPreview: {
            display: false,
            props: {
                id: 0,
                linkedtype: '',
            },
        },
        emailOnboarding: {
            display: false,
            props: {
                callback: '',
            },
        },
        emailConnectionfailed: {
            display: false,
            props: {},
        },
        changeOwner: {
            display: false,
            props: {
                rows: [],
            },
        },
        changeGenerationMode: {
            display: false,
            props: {
                rows: [],
            },
        },
        editRecurringServicePeriod: {
            display: false,
            props: {
                rows: [],
            },
        },
        addRecurringTerm: {
            display: false,
            props: {
                rows: [],
            },
        },
        documentValidation: {
            display: false,
            props: {
                rows: [],
            },
        },
        avatarUploader: {
            display: false,
            props: {
                avatar: {},
                route: '',
            },
        },
        transferTransactionForm: {
            display: false,
            props: {},
        },
        calendarView: {
            display: false,
            props: {},
        },
        staffForm: {
            display: false,
            props: {
                staff: {},
                fromLegacy: false,
            },
        },
        popupQuotaLimit: {
            display: false,
            props: {
                title: '',
                message: '',
            },
        },
        popupMailchimpSettings: {
            display: false,
            props: {
                mode: '',
                callback: '',
            },
        },
        popupMailjetSettings: {
            display: false,
            props: {
                mode: '',
                callback: '',
            },
        },
        popupMassEditPrefs: {
            display: false,
            props: {
                type: '',
                rows: [],
                emitEditSuccess: '',
            },
        },
        popupMassEditVatMode: {
            display: false,
            props: {
                type: '',
                rows: [],
                emitEditSuccess: '',
            },
        },
        popupSchedulerSettings: {
            display: false,
            props: {
                defaultEmail: '',
            },
        },
        popupManagerPaymentCard: {
            display: false,
            props: {
                mode: 'add',
            },
        },
        esignPopupProvider: {
            display: false,
            props: {
                mode: '',
            },
        },
        backupCodes2FA: {
            display: false,
            props: {
                backupCodes: [],
            },
        },
        deactivate2FA: {
            display: false,
            props: {
                provider: false,
                requiredFromCorp: false,
                providers: [],
            },
        },
        removeTrustedDevice: {
            display: false,
            props: {
                trustedDevice: {},
            },
        },
        activate2FAProvider: {
            display: false,
            props: {
                provider: null,
            },
        },
        adyenPopup: {
            display: false,
            props: {},
        },
        cashflowPopupWarning: {
            display: false,
            props: {},
        },
        popupCheckSendingEmail: {
            display: false,
            props: {
                mode: 'checking',
            },
        },
        importDetailPopup: {
            display: false,
            props: {
                importId: null,
            },
        },
        importRevertPopup: {
            display: false,
            props: {
                importToRevert: null,
            },
        },
        importCancelPopup: {
            display: false,
            props: {
                batchId: '',
                type: '',
            },
        },
        onboardingScreenPanel: {
            display: false,
            props: {},
        },
        featureModal: {
            display: false,
            props: {},
        },
        aiCancelModal: {
            display: false,
            props: {},
        },
        activityFormPanel: {
            display: false,
            props: {
                id: null,
                related: null,
                callback: null,
                activityType: '',
            },
        },
        phoneCallFormPanel: {
            display: false,
            props: {
                id: null,
                related: null,
                callback: null,
                scheduled: false,
            },
        },
        activityDetailPanel: {
            display: false,
            props: {
                activityDetailDisplayed: null,
                callback: null,
                shouldFetchAdditionalData: false,
            },
        },
        activityDeleteDialog: {
            display: false,
            props: {
                activity: null,
                callback: null,
            },
        },
        activitiesListingMassReschedule: {
            display: false,
            props: {
                selectedActivities: [],
                workingDays: [],
                callback: null,
            },
        },
        popupMarkPhoneCallDone: {
            display: false,
            props: {
                idPhoneCall: null,
                callback: null,
                date: null,
                description: '',
            },
        },
        activitiesMassMarkAsDone: {
            display: false,
            props: {
                selectedActivities: [],
                onSuccess: null,
                onError: null,
            },
        },
        activitiesListingMassModifyOwner: {
            display: false,
            props: {
                selectedActivities: [],
                onSuccess: null,
                onError: null,
            },
        },
        activitiesListingMassAssign: {
            display: false,
            props: {
                selectedActivities: [],
                onSuccess: null,
                onError: null,
            },
        },
        activitiesListingMassDelete: {
            display: false,
            props: {
                selectedActivities: [],
                onSuccess: null,
                onError: null,
            },
        },
        myActivitiesCardConfigDialog: {
            display: false,
            props: {},
        },
        connectionConsentDialog: {
            display: false,
            props: {
                demandType: 'support',
                staff: [],
                thirdId: null,
                corpId: null,
            },
        },
        activitiesLinkObjectDialog: {
            display: false,
            props: {
                callback: null,
            },
        },
        alert: {
            display: false,
            props: {
                title: '',
                message: '',
            },
        },
        createProgressInvoiceBlockByDraftDialog: {
            display: false,
            props: {
                docId: null,
                invoiceType: null,
            },
        },
        dialogValidateProgressInvoice: {
            display: false,
            props: {
                isFinalInvoice: false,
                id: '',
                fromOverview: false,
            },
        },
        cancelProgressInvoiceDialog: {
            display: false,
            props: {
                lastProgressInvoiceId: null,
            },
        },
        emailDeleteConfirmDialog: {
            display: false,
            props: {
                email: null,
            },
        },
        documentHasProgressInvoiceDialog: {
            display: false,
            props: {},
        },
        dialogMissingFeaturesProgressInvoice: {
            display: false,
            props: {},
        },
        dialogProgressInvoiceSelectType: {
            display: false,
            props: {},
        },
        documentNotAuthorized: {
            display: false,
            props: {},
        },
        automationDeleteDialog: {
            display: false,
            props: {
                automation: {},
            },
        },
        automationRenameDialog: {
            display: false,
            props: {
                automation: {},
            },
        },
        automationWizardPanel: {
            display: false,
            template: null,
            automation: null,
            isEditMode: false,
        },
        automationModalUpdateVersion: {
            display: false,
            props: {
                automations: [],
            },
        },
        docFormErrorDialog: {
            display: false,
            props: {},
        },
        contactPanel: {
            display: false,
            props: {},
        },
        customfieldHistoryPanel: {
            display: false,
            props: {},
        },
        companyInformationSuccessDialog: {
            display: false,
            props: {},
        },
        companyInformationLockDialog: {
            display: false,
            props: {},
        },
        ecoTaxDialog: {
            display: false,
            props: {},
        },
        vatRateDialog: {
            display: false,
            props: {},
        },
        rateCategoryDialog: {
            display: false,
            props: {},
        },
        vatCheckDialog: {
            display: false,
            props: {},
        },
        draftNumberingConfirmationModal: {
            display: false,
            props: {},
        },
        draftNumberingModal: {
            display: false,
            props: {},
        },
        purchaseImportModal: {
            display: false,
            props: {},
        },
        unitsModal: {
            display: false,
            props: {},
        },
        popupMassUpdateBankInfo: {
            display: false,
            props: {
                rows: [],
                emitEditSuccess: '',
            },
        },
        stancerModal: {
            display: false,
            props: {},
        },
        staffConfirmDeleteModal: {
            display: false,
            props: {
                staffId: null,
            },
        },
        staff2FAScheduleModal: {
            display: false,
            props: {
                isEdition: false,
            },
        },
        staff2FACancelModal: {
            display: false,
            props: {
                isActive: false,
            },
        },
        staffOneOffBackupCodeModal: {
            display: false,
            props: {
                staff: {},
            },
        },
        customFieldsSettingsModal: {
            display: false,
            props: {},
        },
        confirmChangeOwnerModal: {
            display: false,
            props: {
                staffId: null,
                name: '',
            },
        },
        assignedStaffLabelsModal: {
            display: false,
            props: defaultProps.assignedStaffLabelsModal,
        },
        exportRenameModal: {
            display: false,
            props: {},
        },
    },
    mutations: {
        feedProps(state, payload) {
            state[payload.key].props = { ...state[payload.key].props, ...payload.props };
        },
        open(state, key) {
            state[key].display = true;
        },
        close(state, key) {
            state[key].display = false;
        },
    },
    actions: {
        open({ commit }, payload) {
            commit('feedProps', payload);
            commit('open', payload.key);
        },
        close({ commit, state }, payload) {
            if (defaultProps[payload.key]) {
                // Reset props to default if it exists
                state[payload.key].props = { ...defaultProps[payload.key] };
            }
            commit('close', payload.key);
        },
        feedProps({ commit }, payload) {
            commit('feedProps', payload);
        },
    },
};

const factory = () => {
    return {
        ...store,
    };
};

export { store as default, factory };
